<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <div style="margin-top: 2px">
            <el-button type="primary" size="mini" :disabled="!btn.updateHour" @click.native.prevent="updateManHour(0)">{{$t('getapi[7128]')}}</el-button>
        </div>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="ProDirectReportViewInfo"
                :filter_language="['audit_flag']"
                :filter_thousandth="['plan_finish_qty','report_qty','scrap_qty','rework_qty','report_manhour','qty','review_qty','imgcount']"
                :header="tableHeader"
                :option="tableOption"
                ref="singleTable"
                :checkflg="false"
                @lct="getSoReport"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[573]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[574]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="routing_desc" :label="$t('getapi[575]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="workcenter_code" :label="$t('getapi[4361]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="workcenter_name" :label="$t('getapi[882]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="next_routing_desc" :label="$t('getapi[4903]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="plan_finish_qty" :label="$t('getapi[4516]')" sortable align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="report_qty" :label="$t('getapi[4905]')" sortable align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="scrap_qty" :label="$t('getapi[4220]')" sortable align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="rework_qty" :label="$t('getapi[4906]')" sortable align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="report_manhour" :label="$t('getapi[4907]')" sortable align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="report_man" :label="$t('getapi[4908]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="report_time" :label="$t('getapi[4909]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[1503]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_flag" :label="$t('getapi[552]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[4043]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[4044]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="qty" :label="$t('getapi[7129]')" align="right" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="review_qty" :label="$t('getapi[7130]')" sortable align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="deviceid" :label="$t('getapi[7130]')" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="imgurl" :label="$t('getapi[6391]')" sortable>
                <template slot-scope="scope">
                    <span style="text-decoration: underline;color: blue" @click="searchPic(scope.row.imgurl)" v-if="scope.row.imgurl != null && scope.row.imgurl != ''">{{$t('getapi[7132]')}}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('getapi[6048]')" width="100" fixed="right">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="getSoReport(scope)" type="text" size="mini">{{$t('getapi[7133]')}}</el-button>
                </template>
            </el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ProDirectReportViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[4025]')" queryData="ProDirectReportViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="showImgData" :title="$t('getapi[7927]')" width="60%">
            <el-table
                    :data="imgData"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="500"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="routing_sequence_No" :label="$t('getapi[573]')"></el-table-column>
                <el-table-column prop="imgurl" :label="$t('getapi[7133]')">
                    <template slot-scope="scope">
                        <a v-if="scope.row.imgurl != '' && scope.row.imgurl != null" @click="searchPic(scope.row.imgurl)" style="text-decoration:underline;color:blue">{{$t('getapi[7133]')}}</a>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

    </div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
    name: '2_reporthistoryview',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3- Common.reduceTableHeight3
        }
    },
    data() {
        return {
            tableHeader: [],
            dataSet: [], // 主表数据
            isVisible: false, // 查询列表是否显示
            queryData: [], // 查询数组
            userData: [], // 用户信息
            DbTbNames: '',
            pageIndex: 1, // 当前页
            pageSize: this.$http.getPageSize('2_reporthistoryview'), // 当前页数据量
            SelectIndexs: 1, //当前页面
            total: 0, // 数据总量
            loading: false, // 主表加载状态
            btn:{
                //补刷工时
                updateHour:false,
            },
            showImgData: false,
            imgData: [],
            scrollTop:0,
        };
    },
    beforeRouteEnter(to, form, next) {
        next(vm => {
            if ((form.name == 'prorelation' || form.name == 'reportdirectly' || form.name =='2_solevel') && Object.keys(vm.$store.state.sharedParams).length > 0) {
                const data = {...vm.$store.state.sharedParams};
                let arr = []
                arr.push({
                    query_Condition: data.order_no,
                    query_field_name: "so_code",
                    query_field_type: "txt",
                    query_sort: "",
                    row_sign: 0
                })
                let parm = {
                    PageIndex: vm.pageIndex,
                    PageSize: vm.pageSize,
                    SelectIndex: vm.SelectIndexs,
                    Param: arr
                };
                vm.$http.urlpost('/Pro/Report/RHistoryViewDataList', parm, function(res) {
                    if (res.Success == 1) {
                        vm.dataSet = res.DataContent;
                        vm.total = res.Totals;
                        vm.loading = false;
                        vm.DbTbNames = res.DbTbNames;
                        vm.authority();
                    }
                });
                vm.$store.commit('clearSharedParams')
            }
        });
    },
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
    mounted: function() {
        let that = this;
        that.colsort();
        that.userData = sessionStorage.getItem('userData');
        that.authority();
    },
    methods: {
        colsort() {
            let that = this;
            that.$loadviewfields.Fileds('ProDirectReportViewInfo', 0, PFileds => {
                that.tableHeader = PFileds;
            });
        },
        sortclick(val) {
            if (val == 1) {
                this.colsort();
            }
        },
        // 修改表格顺序
        opentable() {
            this.$refs.ctab.clearInputs(true);
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6591]"),this.$t("getapi[6589]"));
        },
        authority() {
            let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
            that.btn.updateHour=false;
            if (that.$limits.authority('plv4', 313, 1) == 1) {
                that.btn.updateHour=true;
            }
            //只读权
            if (that.$limits.ReadOnlyRightsView('plv2', 208, 1, that.total)) {
                if (that.total > 0) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                } else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
            }
            //操作权限-查询级别
            var limits = that.$limits.OperationAuthorityView('plv2', 208, 1, that.total);
            // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
            switch (limits) {
                case -1:
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    break;
                case 1:
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    break;
                case -2:
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    break;
                case 2:
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    break;
                case -3:
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    break;
                case 3:
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    break;
                default:
                    break;
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.$http.savePageSize('2_reporthistoryview',val)
            this.getView();
            this.authority();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getView();
            this.authority();
        },
        // 查询
        search() {
            let that = this;
            that.isVisible = true;
            that.$refs.ser.clearInput(that.isVisible, 'ProDirectReportViewInfo');
        },
        //获取查询条件
        serclick(val) {
            this.queryData = val;
            this.confirmGetView();
        },
        // 确认获取数据
        confirmGetView() {
            let that = this;
            that.pageIndex = 1
            that.isVisible = false;
            that.getView();
        },
        // 数据一览
        getView() {
            let that = this;
            that.loading = true;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let token = JSON.parse(that.userData).token;
            let data = {
                PageIndex: that.pageIndex,
                PageSize: that.pageSize,
                SelectIndex: that.SelectIndexs,
                Param: datac
            };
            that.$http.urlpost('/Pro/Report/RHistoryViewDataList', data, function(res) {
                if (res.Success == 1) {
                    that.dataSet = res.DataContent;
                    that.total = res.Totals;
                    that.loading = false;
                    that.DbTbNames = res.DbTbNames;
                    that.authority();
                } else {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                }
            });
        },
        // 刷新
        reflash() {
            let that = this;
            that.getView();
        },
        // 导出
        exps() {
            let that = this;
            that.loading = true;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                PageIndex: that.PageIndex,
                PageSize: that.PageSize,
                SelectIndex: that.SelectIndex,
                Ids: '',
                Param: datac
            };
            that.$refs.SetBtn.SetOneBtnEnable('exps',false);
            that.$http.urlpost('/Pro/Report/RHistoryExportToExecl', parm, function(res) {
                that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                if (res.Success == 1) {
                    let hrefurl = Common.Url + res.DataContent.URL;
                    window.open(hrefurl);
                }
                that.loading = false;
            });
        },
        updateManHour(val){
            let that = this
            let parm = {
                iscontinue: val,
                LangType:that.$processdata.getLang()
            }
            that.$http.urlpost('/Pro/Report/UpdateManhour', parm, function(res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                } else if (res.Success == 2) {
                    that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.updateManHour(1);
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                }
            });
        },
        //查询图片
        searchPic(url){
            window.open(Common.AppUrl + url);
        },
        // 查询图片
        getSoReport(row){
            let that = this
            let parm = {
                so_code: row.row.so_code,
                routing_sequence_No: row.row.routing_sequence_no
            }
            that.$http.urlpost('/Pro/Report/GetSoReportImg', parm, function (res) {
                if (res.Success == 1) {
                    that.imgData = res.DataContent
                    that.showImgData = true
                }
            });
        },
        // 查看图片
        open(url){
            let hrefurl = url;
            window.open(hrefurl);
        },
    }
};
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
